// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteChatChatsByChatIdData, DeleteChatChatsByChatIdParticipantsByUserIdData, DeleteChatChatsByChatIdParticipantsByUserIdResponses, DeleteChatChatsByChatIdResponses, DeleteChatChatsByChatIdTypingData, DeleteChatChatsByChatIdTypingResponses, DeleteChatFilesByFileIdData, DeleteChatFilesByFileIdResponses, DeleteChatMessagesByMessageIdData, DeleteChatMessagesByMessageIdReactionsByEmojiData, DeleteChatMessagesByMessageIdReactionsByEmojiResponses, DeleteChatMessagesByMessageIdResponses, DeleteMediaFilesByFileIdData, GetChatChatsByChatIdData, GetChatChatsByChatIdMessagesData, GetChatChatsByChatIdMessagesResponses, GetChatChatsByChatIdParticipantsData, GetChatChatsByChatIdParticipantsResponses, GetChatChatsByChatIdResponses, GetChatChatsByChatIdUnreadData, GetChatChatsByChatIdUnreadResponses, GetChatChatsData, GetChatChatsResponses, GetChatFilesByFileIdData, GetChatFilesByFileIdResponses, GetChatMessagesByMessageIdData, GetChatMessagesByMessageIdResponses, GetChatMessagesSearchData, GetChatMessagesSearchResponses, GetChatThreadsByMessageIdRepliesData, GetChatThreadsByMessageIdRepliesResponses, GetMediaFilesByFileIdData, GetMediaFilesByFileIdDownloadUrlData, PostChatChatsByChatIdMessagesData, PostChatChatsByChatIdMessagesResponses, PostChatChatsByChatIdParticipantsData, PostChatChatsByChatIdParticipantsResponses, PostChatChatsByChatIdReadData, PostChatChatsByChatIdReadResponses, PostChatChatsByChatIdTypingData, PostChatChatsByChatIdTypingResponses, PostChatChatsData, PostChatChatsResponses, PostChatFilesData, PostChatFilesResponses, PostChatMessagesByMessageIdReactionsData, PostChatMessagesByMessageIdReactionsResponses, PostChatThreadsByMessageIdRepliesData, PostChatThreadsByMessageIdRepliesResponses, PostMediaFilesBatchData, PostMediaFilesRegisterData, PostMediaFilesUploadUrlData, PutChatChatsByChatIdData, PutChatChatsByChatIdResponses, PutChatMessagesByMessageIdData, PutChatMessagesByMessageIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List all chats for the current user
 */
export const getChatChats = <ThrowOnError extends boolean = false>(options?: Options<GetChatChatsData, ThrowOnError>) => (options?.client ?? client).get<GetChatChatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats',
    ...options
});

/**
 * Create a new chat
 */
export const postChatChats = <ThrowOnError extends boolean = false>(options?: Options<PostChatChatsData, ThrowOnError>) => (options?.client ?? client).post<PostChatChatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete a chat
 */
export const deleteChatChatsByChatId = <ThrowOnError extends boolean = false>(options?: Options<DeleteChatChatsByChatIdData, ThrowOnError>) => (options?.client ?? client).delete<DeleteChatChatsByChatIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}',
    ...options
});

/**
 * Get a single chat by ID
 */
export const getChatChatsByChatId = <ThrowOnError extends boolean = false>(options?: Options<GetChatChatsByChatIdData, ThrowOnError>) => (options?.client ?? client).get<GetChatChatsByChatIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}',
    ...options
});

/**
 * Update a chat
 */
export const putChatChatsByChatId = <ThrowOnError extends boolean = false>(options?: Options<PutChatChatsByChatIdData, ThrowOnError>) => (options?.client ?? client).put<PutChatChatsByChatIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List messages in a chat with pagination
 */
export const getChatChatsByChatIdMessages = <ThrowOnError extends boolean = false>(options?: Options<GetChatChatsByChatIdMessagesData, ThrowOnError>) => (options?.client ?? client).get<GetChatChatsByChatIdMessagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/messages',
    ...options
});

/**
 * Send a message to a chat
 */
export const postChatChatsByChatIdMessages = <ThrowOnError extends boolean = false>(options?: Options<PostChatChatsByChatIdMessagesData, ThrowOnError>) => (options?.client ?? client).post<PostChatChatsByChatIdMessagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List participants in a chat
 */
export const getChatChatsByChatIdParticipants = <ThrowOnError extends boolean = false>(options?: Options<GetChatChatsByChatIdParticipantsData, ThrowOnError>) => (options?.client ?? client).get<GetChatChatsByChatIdParticipantsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/participants',
    ...options
});

/**
 * Add participants to a chat
 */
export const postChatChatsByChatIdParticipants = <ThrowOnError extends boolean = false>(options?: Options<PostChatChatsByChatIdParticipantsData, ThrowOnError>) => (options?.client ?? client).post<PostChatChatsByChatIdParticipantsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove a participant from a chat
 */
export const deleteChatChatsByChatIdParticipantsByUserId = <ThrowOnError extends boolean = false>(options?: Options<DeleteChatChatsByChatIdParticipantsByUserIdData, ThrowOnError>) => (options?.client ?? client).delete<DeleteChatChatsByChatIdParticipantsByUserIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/participants/{user_id}',
    ...options
});

/**
 * Mark messages as read
 */
export const postChatChatsByChatIdRead = <ThrowOnError extends boolean = false>(options?: Options<PostChatChatsByChatIdReadData, ThrowOnError>) => (options?.client ?? client).post<PostChatChatsByChatIdReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/read',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Send typing indicator stop
 */
export const deleteChatChatsByChatIdTyping = <ThrowOnError extends boolean = false>(options?: Options<DeleteChatChatsByChatIdTypingData, ThrowOnError>) => (options?.client ?? client).delete<DeleteChatChatsByChatIdTypingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/typing',
    ...options
});

/**
 * Send typing indicator start
 */
export const postChatChatsByChatIdTyping = <ThrowOnError extends boolean = false>(options?: Options<PostChatChatsByChatIdTypingData, ThrowOnError>) => (options?.client ?? client).post<PostChatChatsByChatIdTypingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/typing',
    ...options
});

/**
 * Get unread message count
 */
export const getChatChatsByChatIdUnread = <ThrowOnError extends boolean = false>(options?: Options<GetChatChatsByChatIdUnreadData, ThrowOnError>) => (options?.client ?? client).get<GetChatChatsByChatIdUnreadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/chats/{chat_id}/unread',
    ...options
});

/**
 * Upload a file attachment
 */
export const postChatFiles = <ThrowOnError extends boolean = false>(options?: Options<PostChatFilesData, ThrowOnError>) => (options?.client ?? client).post<PostChatFilesResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/files',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Delete a file
 */
export const deleteChatFilesByFileId = <ThrowOnError extends boolean = false>(options?: Options<DeleteChatFilesByFileIdData, ThrowOnError>) => (options?.client ?? client).delete<DeleteChatFilesByFileIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/files/{file_id}',
    ...options
});

/**
 * Get file info
 */
export const getChatFilesByFileId = <ThrowOnError extends boolean = false>(options?: Options<GetChatFilesByFileIdData, ThrowOnError>) => (options?.client ?? client).get<GetChatFilesByFileIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/files/{file_id}',
    ...options
});

/**
 * Delete a message
 */
export const deleteChatMessagesByMessageId = <ThrowOnError extends boolean = false>(options?: Options<DeleteChatMessagesByMessageIdData, ThrowOnError>) => (options?.client ?? client).delete<DeleteChatMessagesByMessageIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/messages/{message_id}',
    ...options
});

/**
 * Get a single message
 */
export const getChatMessagesByMessageId = <ThrowOnError extends boolean = false>(options?: Options<GetChatMessagesByMessageIdData, ThrowOnError>) => (options?.client ?? client).get<GetChatMessagesByMessageIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/messages/{message_id}',
    ...options
});

/**
 * Edit a message
 */
export const putChatMessagesByMessageId = <ThrowOnError extends boolean = false>(options?: Options<PutChatMessagesByMessageIdData, ThrowOnError>) => (options?.client ?? client).put<PutChatMessagesByMessageIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/messages/{message_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Add a reaction to a message
 */
export const postChatMessagesByMessageIdReactions = <ThrowOnError extends boolean = false>(options?: Options<PostChatMessagesByMessageIdReactionsData, ThrowOnError>) => (options?.client ?? client).post<PostChatMessagesByMessageIdReactionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/messages/{message_id}/reactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove a reaction from a message
 */
export const deleteChatMessagesByMessageIdReactionsByEmoji = <ThrowOnError extends boolean = false>(options?: Options<DeleteChatMessagesByMessageIdReactionsByEmojiData, ThrowOnError>) => (options?.client ?? client).delete<DeleteChatMessagesByMessageIdReactionsByEmojiResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/messages/{message_id}/reactions/{emoji}',
    ...options
});

/**
 * Search messages
 */
export const getChatMessagesSearch = <ThrowOnError extends boolean = false>(options?: Options<GetChatMessagesSearchData, ThrowOnError>) => (options?.client ?? client).get<GetChatMessagesSearchResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/messages/search',
    ...options
});

/**
 * Get replies to a message thread
 */
export const getChatThreadsByMessageIdReplies = <ThrowOnError extends boolean = false>(options?: Options<GetChatThreadsByMessageIdRepliesData, ThrowOnError>) => (options?.client ?? client).get<GetChatThreadsByMessageIdRepliesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/threads/{message_id}/replies',
    ...options
});

/**
 * Reply to a message thread
 */
export const postChatThreadsByMessageIdReplies = <ThrowOnError extends boolean = false>(options?: Options<PostChatThreadsByMessageIdRepliesData, ThrowOnError>) => (options?.client ?? client).post<PostChatThreadsByMessageIdRepliesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/chat/threads/{message_id}/replies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete a file
 */
export const deleteMediaFilesByFileId = <ThrowOnError extends boolean = false>(options?: Options<DeleteMediaFilesByFileIdData, ThrowOnError>) => (options?.client ?? client).delete<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/media/files/{file_id}',
    ...options
});

/**
 * Get file info
 */
export const getMediaFilesByFileId = <ThrowOnError extends boolean = false>(options?: Options<GetMediaFilesByFileIdData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/media/files/{file_id}',
    ...options
});

/**
 * Generate pre-signed download URL
 */
export const getMediaFilesByFileIdDownloadUrl = <ThrowOnError extends boolean = false>(options?: Options<GetMediaFilesByFileIdDownloadUrlData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/media/files/{file_id}/download-url',
    ...options
});

/**
 * Get multiple files by IDs
 */
export const postMediaFilesBatch = <ThrowOnError extends boolean = false>(options?: Options<PostMediaFilesBatchData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/media/files/batch',
    ...options
});

/**
 * Register file after upload
 */
export const postMediaFilesRegister = <ThrowOnError extends boolean = false>(options?: Options<PostMediaFilesRegisterData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/media/files/register',
    ...options
});

/**
 * Generate pre-signed upload URL
 */
export const postMediaFilesUploadUrl = <ThrowOnError extends boolean = false>(options?: Options<PostMediaFilesUploadUrlData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/media/files/upload-url',
    ...options
});
